import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class PopularCourseFaqService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    getByAdmin(popularCourseId): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.POPULAR_COURSE_FAQ(popularCourseId));
    }

    createByAdmin(popularCourseId, data): Observable<any> {
        return this.postRequest(AppUrl.POPULAR_COURSE_FAQ(popularCourseId), data);
    }

    deleteByAdmin(popularCourseId, id): Observable<any> {
        return this.deleteRequest(AppUrl.POPULAR_COURSE_FAQ_DELETE(popularCourseId, id));
    }
}
